import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.8, ease: 'easeOut' },
    },
  };

  const floatingVariants = {
    animate: {
      y: [0, -20, 0],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <div className="home">
      <motion.div
        className="home-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="hero-content">
          <motion.div className="hero-text">
            <motion.div
              className="hero-name"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="greeting">Hello, I'm</span>
              <h2 className="name">SJ YUVAN DHURKESH</h2>
            </motion.div>

            <motion.div
              className="hero-buttons"
              variants={itemVariants}
            >
              <Link to="/projects">
                <motion.button
                  className="btn-primary"
                  whileHover={{ scale: 1.05, boxShadow: '0 10px 30px rgba(88, 101, 242, 0.4)' }}
                  whileTap={{ scale: 0.95 }}
                >
                  View Projects →
                </motion.button>
              </Link>
              <motion.a
                href="/resume_yuvan (2).pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
                whileHover={{ scale: 1.05, boxShadow: '0 10px 30px rgba(139, 92, 246, 0.4)' }}
                whileTap={{ scale: 0.95 }}
              >
                📄 View Resume
              </motion.a>
            </motion.div>
          </motion.div>

          <motion.div
            className="hero-image"
            variants={floatingVariants}
            animate="animate"
          >
            <div className="image-frame">
              <div className="image-placeholder">
                <img src="/profilepic.jpeg" alt="SJ Yuvan Dhurkesh" className="profile-image" />
              </div>
              <motion.div
                className="shape shape-1"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
              />
              <motion.div
                className="shape shape-2"
                animate={{ rotate: -360 }}
                transition={{ duration: 15, repeat: Infinity, ease: 'linear' }}
              />
              <motion.div className="icon icon-1">📊</motion.div>
              <motion.div className="icon icon-2">▶️</motion.div>
              <motion.div className="icon icon-3">✓</motion.div>
              <motion.div className="icon icon-4">+</motion.div>
            </div>
          </motion.div>
        </motion.div>
      </motion.div>

      {/* Background decorations */}
      <div className="bg-decoration">
        <motion.div
          className="floating-shape shape-bg-1"
          animate={{ y: [0, 30, 0], x: [0, 20, 0] }}
          transition={{ duration: 8, repeat: Infinity }}
        />
        <motion.div
          className="floating-shape shape-bg-2"
          animate={{ y: [0, -40, 0], x: [0, -30, 0] }}
          transition={{ duration: 10, repeat: Infinity }}
        />
      </div>
    </div>
  );
};

export default Home;
